import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFolder,
  faEllipsisV,
  faEdit,
  faTrash,
  faFileAlt,
} from "@fortawesome/free-solid-svg-icons";
import "./ComplianceFolder.css";

const ComplianceFolder = ({ folder, onEdit, onDelete }) => {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = React.useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    if (!menuOpen) return;
    const handleOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", handleOutside);
    return () => document.removeEventListener("mousedown", handleOutside);
  }, [menuOpen]);

  const handleMenuToggle = () => {
    setMenuOpen(!menuOpen);
  };

  const handleEdit = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setMenuOpen(false);
    const folderId = folder.id || folder._id;
    onEdit(folderId);
  };

  const handleDelete = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setMenuOpen(false);
    const folderId = folder.id || folder._id;
    onDelete(folderId);
  };

  const folderId = folder.id || folder._id;
  const folderColor = folder.color || "#2196F3";
  const documentCount = folder.documentCount || 0;
  const subfolderCount = folder.subfolderCount || 0;

  const isSystemFolder = folder.isSystem;

  return (
    <div
      className="compliance-folder-link"
      onClick={() => navigate(`/compliance-management/${folderId}`)}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          navigate(`/compliance-management/${folderId}`);
        }
      }}
    >
      <div
        className="compliance-folder-card"
        style={{ borderLeftColor: folderColor }}
      >
        <div className="folder-header">
          <div className="folder-icon-section">
            <FontAwesomeIcon
              icon={faFolder}
              className="folder-icon"
              style={{ color: folderColor }}
            />
          </div>
          <div className="folder-menu" ref={menuRef}>
            <button
              className="menu-toggle-btn"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                handleMenuToggle();
              }}
            >
              <FontAwesomeIcon icon={faEllipsisV} />
            </button>
            {menuOpen && (
              <div className="folder-dropdown-menu">
                <button className="menu-item" onClick={handleEdit}>
                  <FontAwesomeIcon icon={faEdit} /> Edit
                </button>
                <button
                  className="menu-item delete-item"
                  onClick={handleDelete}
                  disabled={isSystemFolder}
                  title={
                    isSystemFolder
                      ? "Deleting system folders is blocked for now"
                      : undefined
                  }
                >
                  <FontAwesomeIcon icon={faTrash} /> Delete
                </button>
              </div>
            )}
          </div>
        </div>

        <div className="folder-content">
          <h3 className="folder-name">{folder.name}</h3>
          {folder.description && (
            <p className="folder-description">{folder.description}</p>
          )}
        </div>

        <div className="folder-footer">
          <div className="folder-stats">
            <span className="stat-item">
              <FontAwesomeIcon icon={faFolder} className="doc-icon" />
              {subfolderCount}{" "}
              {subfolderCount === 1 ? "subfolder" : "subfolders"}
            </span>
            <span className="stat-separator">•</span>
            <span className="stat-item">
              <FontAwesomeIcon icon={faFileAlt} className="doc-icon" />
              {documentCount} {documentCount === 1 ? "document" : "documents"}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ComplianceFolder;
